import PropTypes from "prop-types";
import React from "react";
import styles from "./AddedPopup.module.css";
import Portal from "Shared/Portal";

//Icons
import cartIcon from "./Cart_Icon.svg";
import listIcon from "../../assets/ListNotificationIcon.svg";
import favoritesIcon from "./Favorite_selected.svg";

export const AddedPopup = ({ variants, isAdded }) => {
  const firstLetterCapital = (variant) => {
    if (!variant) return variant;
    else if (variant === "list")
      return variant.charAt(0).toUpperCase() + variant.slice(1) + "s";
    else return variant.charAt(0).toUpperCase() + variant.slice(1);
  };
  const imgType = (variant) => {
    if (variant === "cart")
      return <img className={styles.imgIcon} src={cartIcon} alt="Cart Icon" />;
    else if (variant === "list")
      return (
        <img
          className={`${styles.imgIcon} ${styles.listIcon}`}
          src={listIcon}
          alt="List Icon"
        />
      );
    else
      return (
        <img
          className={`${styles.imgIcon} ${styles.favoritesIcon}`}
          src={favoritesIcon}
          alt="Favorites Icon"
        />
      );
  };

  return (
    <>
      {isAdded && (
        <Portal>
          <div className={styles.container}>
            <div>{imgType(variants)}</div>
            <div className={styles.addTo}>
              Added to {firstLetterCapital(variants)}
            </div>
          </div>
        </Portal>
      )}
    </>
  );
};

AddedPopup.propTypes = {
  variants: PropTypes.oneOf(["cart", "list", "favorites"]),
};
